import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: ()=> import("@/pages/login/login"),
    },
    {
      path: '/register',
      name: 'register',
      component: ()=> import("@/pages/login/registerEditInfo"),
    },
    {
      path: '/registerInfo',
      name: 'registerInfo',
      component: ()=> import("@/pages/login/registerInfo"),
    },
    {
      path: '/systemInfo',
      name: 'systemInfo',
      component: ()=> import("@/pages/login/systemInfo"),
    },
    {
      path: '/merchantAgreement',
      name: 'merchantAgreement',
      component: ()=> import("@/pages/login/merchant"),
    },
    {
      path: '/unsetLogin',
      name: 'unsetLogin',
      component: ()=> import("@/pages/login/unsetLogin"),
    },
    
    {
      path: '/main',
      name: 'main',
      component: () => import("@/pages/main/index"),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import("@/pages/home/index"),
        },
        {
          path: '/examineFail',
          name: 'examineFail',
          component: () => import("@/pages/home/examineFail"),
        },
        {
          path: '/warnReminder',
          name: 'warnReminder',
          component: () => import("@/pages/home/warnReminder"),
        },
        {
          path: '/storeInfo',
          name: 'storeInfo',
          component: () => import("@/pages/operation/store/storeInfo"),
        },
        {
          path: '/storeInfo/basicInfo',
          name: 'basicInfo',
          component: () => import("@/pages/operation/store/basicInfo"),
        },
        {
          path: '/storeInfo/salesRule',
          name: 'salesRule',
          component: () => import("@/pages/operation/store/salesRule"),
        },
        {
          path: '/storeInfo/storePolicy',
          name: 'storePolicy',
          component: () => import("@/pages/operation/store/storePolicy"),
        },
        {
          path: '/storeInfo/memberPlan',
          name: 'memberPlan',
          component: () => import("@/pages/operation/store/memberPlan"),
        },
        {
          path: '/storeInfo/integralSetting',
          name: 'integralSetting',
          component: () => import("@/pages/operation/store/integralSetting"),
        },
        {
          path: '/storeInfo/orderConfirmSettings',
          name: 'orderConfirmSettings',
          component: () => import("@/pages/operation/store/orderConfirmSettings"),
        },
        {
          path: '/storeInfo/businessHoursSettings',
          name: 'businessHoursSettings',
          component: () => import("@/pages/operation/store/businessHoursSettings"),
        },
        {
          path: '/storeInfo/qualificationsSetting',
          name: 'qualificationsSetting',
          component: () => import("@/pages/operation/store/qualificationsSetting"),
        },
        {
          path: '/reportDocument/reportIndex',
          name: 'reportIndex',
          component: () => import("@/pages/user/reportDocument/reportIndex"),
        },
        {
          path: '/systemSetting',
          name: 'systemSetting',
          component: () => import("@/pages/user/systemSetting/systemSetting"),
        },
        {
          path: '/statistical/details',
          name: 'statistical',
          component: () => import("@/pages/user/statistical/details"),
        },
        {
          path: '/user/wallet',
          name: 'wallet',
          component: () => import("@/pages/user/wallet/wallet"),
        },
        {
          path: '/user/storeInfo',
          name: 'userStoreInfo',
          component: () => import("@/pages/user/storeInfo/storeInfo"),
        },
        {
          path: '/user/editStoreInfo',
          name: 'editStoreInfo',
          component: () => import("@/pages/user/storeInfo/editStoreInfo"),
        },
        {
          path: '/user/userInfo',
          name: 'userInfo',
          component: () => import("@/pages/user/userInfo/userInfo"),
        },
        {
          path: '/user/staffManage',
          name: 'staffManage',
          component: () => import("@/pages/user/staff/staffManage"),
        },
        //店铺
        {
          path: '/store',
          name: 'store',
          component: () => import("@/pages/user/store/index"),
        },
        {
          path: '/store/edit',
          name: 'storeEdit',
          component: () => import("@/pages/user/store/edit"),
        },
        {
          path: '/store/detail',
          name: 'storeDetail',
          component: () => import("@/pages/user/store/detail"),
        },
        //角色管理
        {
          path: '/role',
          name: 'role',
          component: () => import("@/pages/user/role/index"),
        },
        //商品 godos
        {
          path: '/goods',
          name: 'goods',
          component: () => import("@/pages/user/goods/index"),
        },
        {
          path: '/goods/edit',
          name: 'goodsEdit',
          component: () => import("@/pages/user/goods/edit"),
        },
        {
          path: '/goods/detail',
          name: 'goodsDetail',
          component: () => import("@/pages/user/goods/detail"),
        },
        //系统说明
        {
          path: '/user/systemInfo',
          name: 'userSystemInfo',
          component: ()=> import("@/pages/user/systemInfo"),
        },
        //优惠券 coupon
        {
          path: '/coupon',
          name: 'coupon',
          component: () => import("@/pages/user/coupon/index"),
        },
        {
          path: '/coupon/detail',
          name: 'couponDetail',
          component: () => import("@/pages/user/coupon/detail"),
        },
        //首页管理
        {
          path: '/index',
          name: 'index',
          component: () => import("@/pages/user/index/index"),
        },
        // 内容推送
        {
          path: '/content',
          name: 'content',
          component: () => import("@/pages/user/content/index"),
        },
        {
          path: '/content/edit',
          name: 'contentEdit',
          component: () => import("@/pages/user/content/edit"),
        },
        {
          path: '/content/detail',
          name: 'contentDetail',
          component: () => import("@/pages/user/content/detail"),
        },
        //评价管理 evaluate
        {
          path: '/evaluate',
          name: 'evaluate',
          component: () => import("@/pages/user/evaluate/index"),
        },
        {
          path: '/evaluate/appeal',
          name: 'evaluateAppeal',
          component: () => import("@/pages/user/evaluate/appeal"),
        },
        
        //消息中心 
        //系统通知
        {
          path: '/systeam/index',
          name: 'systeamMessage',
          component: () => import("@/pages/message/systeam/index"),
        },
        //订单与物流消息
        {
          path: '/message/order',
          name: 'messageOrder',
          component: () => import("@/pages/message/order/index"),
        },
        //平台客服
        {
          path: '/customerService',
          name: 'customerService',
          component: () => import("@/pages/message/cs/index"),
        },
        {
          path: '/customerService/detail',
          name: 'customerServiceDetail',
          component: () => import("@/pages/message/cs/detail"),
        },
        //订单管理
        // 订单列表
        {
          path: '/order',
          name: 'order',
          component: () => import("@/pages/order/list"),
        },
       //订单详情
       {
        path: '/order/detail',
        name: 'orderDetail',
        component: () => import("@/pages/order/detail"),
      },
      //订单打印
      {
        path: '/order/print',
        name: 'orderPrint',
        component: () => import("@/pages/order/print"),
      },
        
        //其他商城订单
        {
          path: '/otherOrder',
          name: 'otherOrder',
          component: () => import("@/pages/order/otherOrder"),
        },
        // 售后管理
        {
          path: '/saleAfter',
          name: 'saleAfter',
          component: () => import("@/pages/order/saleAfter/index"),
        },
         // 售后详情
         {
          path: '/saleAfter/detail',
          name: 'saleAfterDetail',
          component: () => import("@/pages/order/saleAfter/detail"),
        },
        // 物流管理
        {
          path: '/logistics',
          name: 'logistics',
          component: () => import("@/pages/order/logistics/index"),
        },
         // 物流详情
         {
          path: '/logistics/detail',
          name: 'logisticsDetail',
          component: () => import("@/pages/order/logistics/detail"),
        },
        // 盘点
        {
          path: '/inventory',
          name: 'inventory',
          component: () => import("@/pages/order/logistics/inventory"),
        },
        // 商品处理
        {
          path: '/goodsHandle',
          name: 'goodsHandle',
          component: () => import("@/pages/order/logistics/handle/goodsHandle"),
        },
        // 商品处理 -> 查看详情
        {
          path: '/goodsHandle/detail',
          name: 'goodsHandleDetail',
          component: () => import("@/pages/order/logistics/handle/detail"),
        },

         // 新增/编辑商品处理
         {
          path: '/handleEdit',
          name: 'handleEdit',
          component: () => import("@/pages/order/logistics/handle/edit"),
        },
        //广告
        {
            path: '/order/banner',
            name: 'banner',
            component: () => import("@/pages/order/banner"),
        },
        //用户接待
        {
            path: '/chatIndex',
            name: 'chatIndex',
            component: () => import("@/pages/message/im/im_index"),
        },
        //A
        {
            path: '/chat/a',
            name: 'a',
            component: () => import("@/pages/message/im/A"),
        },
        //b
        {
            path: '/chat/b',
            name: 'b',
            component: () => import("@/pages/message/im/B"),
        },
        // 2022-11-16新增 配送设置
        {
          path: '/deliverySet',
          name: 'deliverySet',
          component: () => import("@/pages/user/deliverySet/index"),
        },
        // 2022-11-16新增 c类订单主页
        {
          path: '/cList',
          name: 'cList',
          component: () => import("@/pages/order/cList"),
        },
      ]
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: ()=> import("@/pages/home/index"),
    // },
    {
        path: '/p_detail',
        name: 'detail',
        component: ()=> import("@/pages/shareH5/product_detail"),
    },
    {
        path: '/d_detail',
        name: 'dynamic_detail',
        component: ()=> import("@/pages/shareH5/dynamic_detail"),
    },
    {
        path: '/download',
        name: 'download',
        component: ()=> import("@/pages/shareH5/download"),
    },
    {
        path: '/openApp',
        name: 'openApp',
        component: ()=> import("@/pages/shareH5/openApp"),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js